import { mapActions, mapGetters, mapState } from 'vuex';
import { MODALS } from '@/components/app/app-modals/app-modals';
import accountVerifyMixin from '@/mixins/accountVerify';
import socialLevelMixin from '@/mixins/socialLevel';

const BALANCE_THRESHOLD = 0;
const DONT_SHOW_LOGIN_AND_SIGN_UP_BUTTONS_ROUTES = [
  'account-page-login',
  'account-page-register',
  'account-password-forgotten',
  'index1',
  'index2',
];


export default {
  mixins: [
    accountVerifyMixin,
    socialLevelMixin,
  ],
  computed: {
    ...mapGetters('user', ['isLoggedIn', 'isUserRestricted']),
    ...mapState('wallet', ['balance']),
    ...mapGetters('app', ['isLayoutMobile', 'isLayoutDesktop']),
    ...mapState('profile', ['settings']),
    showLoginAndSignUpButtons() {
      return !DONT_SHOW_LOGIN_AND_SIGN_UP_BUTTONS_ROUTES.includes(this.$route.name);
    },
    showBalanceHeader() {
      return (this.settings.display) ? this.settings.display.ShowBalanceHeader : true;
    },
    notifyOnLowBalance() {
      return this.balance.accountBalanceDecimal <= BALANCE_THRESHOLD;
    },
  },
  methods: {
    ...mapActions('app', ['closeMobileMenu']),
    ...mapActions('notifications', ['setSideNotification', 'toggleNotificationsWidget']),
    ...mapActions('search', ['toggleSearchBar', 'closeSearchBar']),
    ...mapActions('popup', ['setCurrentPopup']),
    onCashClick() {
      this.closeMobileMenu();
      if (!this.hasUserClassicEnabled) {
        this.setCurrentPopup(MODALS.ACCOUNT_ENABLE_CLASSIC);
        return;
      } else if (!this.isUserVerified) {
        this.showAccountVerifyPopup();
        return;
      }
      this.$router.push({ name: 'wallet' });
    },
    onInvestmentClick() {
      this.closeMobileMenu();
      this.$router.push({ name: 'portfolio' });
    },
    onSignUp() {
      this.closeMobileMenu();
      this.setCurrentPopup(MODALS.REGISTER);
    },
    onLogin() {
      this.closeMobileMenu();
      this.setCurrentPopup(MODALS.LOGIN);
    },
    openDepositPopup() {
      if (!this.hasUserClassicEnabled) {
        this.closeMobileMenu();
        this.setCurrentPopup(MODALS.ACCOUNT_ENABLE_CLASSIC);
      } else if (this.isUserVerified) {
        if (this.$route.name !== 'wallet') {
          this.closeMobileMenu();
          this.setCurrentPopup(MODALS.ADD_FUNDS);
        }
      } else {
        this.closeMobileMenu();
        this.showAccountVerifyPopup();
      }
    },
    onAvatarClick() {
      this.$router.push({ name: 'portfolio' });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/headerNav.js